<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
                <li class="breadcrumb-item active" aria-current="page">Importación de Bonos</li>
            </ol>
        </nav>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">Importar TRX de bonos</div>
                        <div class="card-body">
                            <form action="#">
                                <md-field :class="{'md-invalid' : errors.concepts_I170}">
                                    <label>Concepto I170</label>
                                    <md-input v-model="I170"></md-input>
                                    <span class="md-error" v-if="this.errors.concepts_I170">{{this.errors.concepts_I170[0]}}</span>
                                </md-field>
                                <md-field :class="{'md-invalid' : errors.concepts_I176}">
                                    <label>Concepto I176</label>
                                    <md-input v-model="I176"></md-input>
                                    <span class="md-error" v-if="this.errors.concepts_I176">{{this.errors.concepts_I176[0]}}</span>
                                </md-field>
                                <md-field :class="{'md-invalid' : errors.concepts_RI270}">
                                    <label>Concepto RI270</label>
                                    <md-input v-model="RI270"></md-input>
                                    <span class="md-error" v-if="this.errors.concepts_RI270">{{this.errors.concepts_RI270[0]}}</span>
                                </md-field>
                                <md-field :class="{'md-invalid' : errors.concepts_RI276}">
                                    <label>Concepto RI276</label>
                                    <md-input v-model="RI276"></md-input>
                                    <span class="md-error" v-if="this.errors.concepts_RI276">{{this.errors.concepts_RI276[0]}}</span>
                                </md-field>
                                <md-field :class="{'md-invalid' : errors.file}">
                                    <label>Archivo Excel (.xlsx)</label>
                                    <md-file ref="file" @change="handleChange" />
                                    <small>
                                        <a
                                            :href="$sanitizeUrl(`${ApiDomain}/storage/import_bonus_template.xlsx`)"
                                            target="_blank" rel="noopener">Desargar plantilla</a>
                                    </small>
                                    <span class="md-error" v-if="this.errors.file">{{this.errors.file[0]}}</span>
                                </md-field>
                            </form>
                        </div>
                        <div class="card-actions">
                            <md-button
                                @click="sendRequest()"
                                :disabled="xhr_processing"
                                class="md-primary md-raised float-right">Procesar</md-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImportBonus",
    data: () => ({
        errors: {},
        file: null,
        xhr_processing: false,
        I170: "Bono promoción por abono STP del 1%",
        I176: "IVA del bono promoción por abono STP del 1%",
        RI270: "Bono promoción por abono STP del 1%",
        RI276: "IVA del bono promoción por abono STP del 1%",
    }),
    methods: {
        handleChange(e) {
            this.file = e.target.files[0];
        },
        async sendRequest() {
            try {
                let form_data = new FormData();
                form_data.append("file", this.file);
                form_data.append("createTrxIVA", "true");
                form_data.append("trxIva", "I176");
                form_data.append("trxIvaMirror", "RI276");
                form_data.append("concepts.I170", this.I170);
                form_data.append("concepts.I176", this.I176);
                form_data.append("concepts.RI270", this.RI270);
                form_data.append("concepts.RI276", this.RI276);
                this.xhr_processing = true;

                const {data} = await axios.post(`/api/imports/trx/bonus`, form_data)
                alert(`Se generaron ${data.length} trx nuevos`)
            } catch (e) {
                if(e.response.status === 422) {
                    this.errors = e.response.data.errors;
                }
            }
            finally {
                this.xhr_processing = false;
            }
        }
    }
}
</script>
<style scoped>
    .card {
        margin-top: 20px;
    }
</style>
